import styled from "styled-components"

export const Container = styled.div`
  padding: 2rem 0;
  position: relative;
  border: 0.1rem solid ${(p) => p.theme.colors.borderLight};
  border-radius: 0.5rem;
  margin: 0 0 1rem;
`

export const Divider = styled.div`
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.turquoiseBorder};
  width: 100%;
  margin: 1rem 0;
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  position: relative;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    padding: 0 2.5rem;
  }

  p,
  h4,
  h3 {
    margin: 0;

    div {
      position: absolute;
      right: 1rem;
      font-size: 1.2rem;
    }
  }
`

export const Provider = styled.div`

`
